module.exports = __webpack_public_path__ + "img/header.0bc32f74.jpg";